import CountUp from "react-countup";

const ScoreCircle = ({ actual, goal, label, color }) => {
  // background color logic
  let bgColor = "#d1dbcf"; // default green
  if (color === "red") bgColor = "#fca5a5";
  if (color === "gray") bgColor = "#e5e7eb";

  const renderAnimatedCount = (val) => {
    if (val == null || val === "") return 0;
    const num = Number(String(val).replace(/,/g, ''));
    return !isNaN(num) ? <CountUp end={num} separator="," duration={2} /> : val;
  };

  return (
    <div className="flex flex-col items-center mb-2">
      {/* Label */}
      <p className="mb-2 head-4 dark-H text-center">{label}</p>

      {/* Circle */}
      <div className="w-24 h-24 rounded-full border border-gray-400 overflow-hidden shadow">

        {/* Top Half */}
        <div
          className="h-1/2 flex items-center justify-center"
          style={{ backgroundColor: bgColor }}
        >
          <span className="head-4 font-semibold leading-tight translate-y-[1px]">
            {renderAnimatedCount(actual)}
          </span>
        </div>

        {/* Divider */}
        <div className="border-t border-black" />

        {/* Bottom Half */}
        <div
          className="h-1/2 flex items-center justify-center"
          style={{ backgroundColor: bgColor }}
        >
          <span className="head-4 font-semibold leading-tight -translate-y-[1px]">
            {renderAnimatedCount(goal)}
          </span>
        </div>

      </div>
    </div>
  );
};

export default ScoreCircle;
